/**
 * Browser-safe replacement for Node's `process.nextTick`.
 *
 * The pre-webpack-5 build auto-polyfilled `process`, whose `nextTick`
 * was implemented on top of `setTimeout(fn, 0)`. Webpack 5 no longer
 * shims `process`, so referencing it in the browser throws
 * `ReferenceError: process is not defined`. This helper defers the
 * callback to the next macrotask, matching the previous behaviour.
 *
 * @param {Function} callback
 * @return {number} timeout id
 */
export default function nextTick(callback) {
  return setTimeout(callback, 0);
}
